import { CONTACT } from '@/lib/contact';

/**
 * The Eco-HQ panel: embedded map, office hours and getting-here details.
 *
 * Shared so the /contact section and the map popup behind the address rows
 * render the same thing. The heading ("Visit Our Eco-HQ") is deliberately NOT
 * here - the section renders it as an <h2> and the dialog uses it as its
 * accessible name, so owning it here would produce two of them.
 *
 * The Google Maps iframe contacts Google as soon as it mounts, so keep this
 * component unmounted until it is actually needed (the dialog only mounts while
 * open, which is why the popup costs nothing on page load).
 */
const HQLocationContent = ({ className = '' }: { className?: string }) => (
  <div className={`overflow-hidden border border-border bg-surface ${className}`}>
    <div className="aspect-16/9 w-full">
      <iframe
        width="100%"
        height="100%"
        loading="lazy"
        title="Flora Dine HQ"
        referrerPolicy="no-referrer-when-downgrade"
        src="https://www.google.com/maps?q=25.34220517581393,82.98863197976283&z=14&output=embed"
        className="border-0"
      />
    </div>

    <div className="bg-muted/30 p-6">
      <div className="grid gap-6 md:grid-cols-2">
        <div>
          <h3 className="mb-4 font-headline text-xl font-bold text-foreground">
            Office Hours{' '}
            <span className="font-body text-sm font-normal text-muted-foreground">
              {CONTACT.officeHours.timezone}
            </span>
          </h3>
          <div className="space-y-2 font-body text-muted-foreground">
            <p>{CONTACT.officeHours.weekdays}</p>
            <p>{CONTACT.officeHours.saturday}</p>
          </div>
        </div>

        <div>
          <h3 className="mb-4 font-headline text-xl font-bold text-foreground">Getting Here</h3>
          <div className="space-y-2 font-body text-muted-foreground">
            <p>{CONTACT.addressLine1}</p>
            <p>{CONTACT.addressLine2}</p>
            <p>Parking: Street parking available</p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default HQLocationContent;
